import React from "react";
import styles from "./HistoriqueConnexion.scss"
import {useAppText} from "src/commun/composants/AppText";
import {useAsync} from "react-async-hook";
import {fetchHistoriqueConnexion} from "src/app/api/AccountApi";
import {Connexion} from "src/domain/HistoriqueConnexion";
import AppCol from "src/commun/composants/grille/AppCol";
import AppSpinner from "src/commun/composants/AppSpinner/AppSpinner";
import AppRow from "src/commun/composants/grille/AppRow";

const HistoriqueConnexion = () => {
  const { tString } = useAppText();
  const connexions = useAsync(fetchHistoriqueConnexion, []);

  const renderHead = () => {
    return (
      <tr>
        <th>{tString("connection.history.column.date")}</th>
        <th>{tString("connection.history.column.ip")}</th>
        <th>{tString("connection.history.column.browser")}</th>
        <th>{tString("connection.history.column.os")}</th>
      </tr>
    )
  }

  const renderLine = (connexion: Connexion, index: number) => {
    return (
      <tr key={"success" + index}>
        <td>{connexion._utime.replace("T", " ")}</td>
        <td>{connexion.ipAddr}</td>
        <td>{connexion.ua_browser}</td>
        <td>{connexion.ua_os}</td>
      </tr>
    )
  }

  if (connexions.status === "loading") {
    return <AppSpinner animation="grow"/>;
  }

  return (
    <span className={`ferge-class`}>
      <AppRow>
        <AppCol className={`${styles.container}`}>
           <div className={`${styles.historiqueConnexion}`}>
            <h2 className="appTitle">{tString("connection.history.success.title")}</h2>
            <span className={styles.tableContainer}>
              <table className={styles.tableHistorique}>
                <thead>
                  {renderHead()}
                </thead>
                <tbody>
                  {(connexions.result?.successLogin || []).map((connexion, index) => renderLine(connexion, index))}
                </tbody>
              </table>
            </span>
          </div>

          <div className={`${styles.separator}`} />

          <div className={`${styles.historiqueConnexion}`}>
            <h2 className="appTitle">{tString("connection.history.failed.title")}</h2>
            <span className={styles.tableContainer}>
              <table className={styles.tableHistorique}>
                <thead>
                  {renderHead()}
                </thead>
                <tbody>
                  {(connexions.result?.failedLogin || []).map((connexion, index) => renderLine(connexion, index))}
                </tbody>
              </table>
            </span>
          </div>
        </AppCol>
      </AppRow>
    </span>
  );
};

export default HistoriqueConnexion;